/* eslint-disable react/style-prop-object */
import ToggleButton from "../../../../../../components/ui/toggle_button/ToggleButton";

export default function MultiSelectionComponent({
    component,
    onUserInput,
    onUserInputComplete,
    defaultValues,
    showStatus
}) {
    // Support both array and single value for defaultValues
    const selectedValues = Array.isArray(defaultValues) ? defaultValues : defaultValues ? [defaultValues] : [];

    const displayAs =
        !Array.isArray(component.properties) ?
            [] :
            (component.properties && (component.properties.find(a => a.property === "displayAs")) && component.properties.find(a => a.property === "displayAs").values)
    const options = !Array.isArray(component.properties) ?
        [] :
        (component.properties && component.properties.find(a => a.property === "Options")) ? JSON.parse(component.properties.find(a => a.property === "Options").values) : [];

    // Handler for toggling selection
    const handleToggle = (optionValue) => {
        let newSelected;
        if (selectedValues.includes(optionValue)) {
            newSelected = selectedValues.filter(v => v !== optionValue);
        } else {
            newSelected = [...selectedValues, optionValue];
        }
        onUserInput(newSelected);
    };

    // Handler for dropdown multi-select
    const handleDropdownChange = (e) => {
        const selected = Array.from(e.target.selectedOptions, opt => opt.value);
        onUserInput(selected);
    };

    return (
        <div>
            {/* {showStatus && component.properties &&
                <div className="d-flex flex-column justify-content-between mb-2 position-absolute shadow p-1 rounded" style={{ top: 0, right: 0, minWidth: 350 }}>
                    <b>Stats (Weights)</b>

                    {
                        component.properties.find(a => a.property === 'Options')
                        && (
                            (
                                typeof component.properties.find(a => a.property === 'Options').values === 'string'
                                &&
                                (
                                    component.properties.find(a => a.property === 'Options').values.startsWith('{') ||
                                    component.properties.find(a => a.property === 'Options').values.startsWith('[')
                                )
                            )
                        )
                        && (Object.keys(JSON.parse(component.properties.find(a => a.property === 'Options').values)))
                            .map((key) => {
                                const property = JSON.parse(component.properties.find(a => a.property === 'Options').values)[key]
                                // if (property.option && property.weight)
                                return <small key={key}
                                    className={`d-flex justify-content-between small opacity-75 p-1 rounded-2 ${selectedValues.includes(property.option) ? '75 bg-primary-container text-light' : ' text-muted '}`}
                                >

                                    <div className="small">{property.option ? property.option : ""}</div>
                                    <div className="small">{property.weight ? property.weight : 0}</div>
                                </small>


                            })
                    }
                </div>} */}
            {
                {
                    "Buttons": <div>
                        {options.map(option => <button
                            type="button"
                            key={`button-${option.option}`}
                            className={`btn w-100 ${selectedValues.includes(option.option) ? 'bg-primary-container' : 'bg-secondary-container'}`}
                            onClick={e => handleToggle(option.option)}
                        >{option.option}</button>)}
                    </div>,
                    "Dropdown": <select
                        className="form-control form-control-sm"
                        multiple
                        value={selectedValues}
                        onChange={handleDropdownChange}
                    >{options.map(option => <option key={`option-${option.option}`} value={option.option}>{option.option}</option>)}
                    </select>,
                }[displayAs] || <div>
                    {options.map(option =>
                        <ToggleButton
                            key={`ToggleButton-${option.option}`}
                            style='tick'
                            defaultValue={selectedValues.includes(option.option)}
                            onToggle={_ => handleToggle(option.option)}
                        >
                            {option.option}
                        </ToggleButton>
                    )}
                </div>
            }
        </div>
    )
}
